import React from 'react';
import { useHistory } from 'react-router-dom';
import VerificationCode from './VerificationCode';
import { Context } from '../../Store/store';
import HttpRequest from '../../Services/HttpRequest';
import ApiRoutes from '../../Services/ApiRoutes';
import { devLog, overlay, setStorageData } from '../../utils/Helper';
import Constants from '../../utils/Constants';

const VCLogic = () => {
    const [state, dispatch] = React.useContext(Context);
    const deviceToken = 123456789;
    const device_type = 'web';
    const history = useHistory();


    const submitFrom = (params) => {
        dispatch({ type: "SET_STATE", response: [], flash_message_show: false });
        overlay(true);
        params.append('device_type', device_type);
        params.append('device_token', deviceToken);
        HttpRequest.makeRequest(
            ApiRoutes.verificationCode.method,
            ApiRoutes.verificationCode.end_point,
            params
        ).then((response) => {
            if (response.resCode === 200) {
                overlay(false);
                dispatch({
                    type: "SET_STATE",
                    response: { status: true, resCode: 200, data: [], message: 'Verification Successful.' },
                    flash_message_show: true
                });
                // setStorageData(Constants.session_key, `Bearer ${response.data.authentication_token}`);
                // setStorageData(Constants.session_object, response.data);
                // setTimeout(() => {
                //     window.location.href=Constants.base_path + `/home`
                // }, 1000);
                setTimeout(() => { history.push("/login") }, 3000);
            } else {
                dispatch({
                    type: 'SET_STATE',
                    response: response,
                    flash_message_show: true
                });
                overlay(false);
            }
        }).catch(err => {
            devLog("error", err);
        });
    };

    React.useEffect(() => {
        dispatch({
            type: 'SET_STATE',
            response: [],
            flash_message_show: false
        });
    }, []);


    return (
        <>
            <VerificationCode submitFrom={submitFrom} />
        </>
    );
}

export default VCLogic;